import { TEST_CATALOG, TEST_CATEGORIES, TEST_PARTNERS } from '../constants'
import { TestsCatalogCard } from './tests/TestsCatalogCard'
import { TestsOverviewCard } from './tests/TestsOverviewCard'
import { useTestsTabState } from './tests/useTestsTabState'

export default function TestsTab() {
  const {
    category,
    setCategory,
    searchQuery,
    setSearchQuery,
    sortMode,
    setSortMode,
    popularOnly,
    togglePopularOnly,
    hasActiveFilters,
    resetFilters,
    filtered,
    orderedTestIds,
    orderMessage,
    orderMessageTone,
    orderingTestId,
    handleOrderTest,
  } = useTestsTabState()
  const popularTests = TEST_CATALOG.filter((test) => test.popular).slice(0, 4)

  return (
    <div className="space-y-6">
      <TestsOverviewCard
        orderedCount={orderedTestIds.size}
        partnerCount={TEST_PARTNERS.length}
        catalogCount={TEST_CATALOG.length}
        categoryCount={TEST_CATEGORIES.length - 1}
        partners={TEST_PARTNERS}
        popularTests={popularTests}
      />

      <TestsCatalogCard
        category={category}
        categories={TEST_CATEGORIES}
        searchQuery={searchQuery}
        onSearchQueryChange={setSearchQuery}
        sortMode={sortMode}
        onSortModeChange={setSortMode}
        popularOnly={popularOnly}
        onTogglePopularOnly={togglePopularOnly}
        hasActiveFilters={hasActiveFilters}
        onResetFilters={resetFilters}
        filtered={filtered}
        orderedCount={orderedTestIds.size}
        orderedTestIds={orderedTestIds}
        orderingTestId={orderingTestId}
        onSelectCategory={setCategory}
        onOrderTest={handleOrderTest}
        orderMessage={orderMessage}
        orderMessageTone={orderMessageTone}
      />
    </div>
  )
}
